import { Record } from 'immutable';

export interface EstablishmentInterface {
    id: number
    name: string
    token: string
    firToken: string
}

const defaultEstablishmentProps: EstablishmentInterface = {
    id: 2343,
    name: "test store",
    token: "",
    firToken: "",
};

class Establishment extends Record(defaultEstablishmentProps) implements EstablishmentInterface {

    getFirEmail(isDev: boolean = false): string {
        return (isDev === true) ? this.id + "_d@popina.com" : this.id + "@popina.com";
    }

    setFirToken(token: string): Establishment {
        return this.update('firToken', (_) => token);
    }
}

export default Establishment;